export default function LinkPair({
  label,
  link,
  edit,
  value,
  loading,
  inputOptions,
}) {
  if (!inputOptions) inputOptions = { id: label.toLowerCase() };
  else if (!inputOptions?.id && !inputOptions?.name)
    inputOptions.id = label.toLowerCase();
  else if (!inputOptions?.name) inputOptions.name = inputOptions.id;
  else if (!inputOptions?.id) inputOptions.id = inputOptions.name;

  if (loading)
    return (
      <div className="grid w-3/4 gap-1">
        <div className="w-1/3 h-4 rounded animate-pulse bg-stone-700"></div>
        <div className="h-6 rounded animate-pulse bg-stone-600"></div>
      </div>
    );
  return (
    <div className="cursor-pointer">
      <p className="text-stone-400">{label}:</p>
      {!edit &&
        (link ? (
          typeof link === "object" ? (
            <div className="flex space-x-2">
              {link.map((l, i) => (
                <a
                  href={l}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-yellow-600 underline"
                >
                  {i + 1}. Link
                </a>
              ))}
            </div>
          ) : (
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-yellow-600 underline"
            >
              {value || "Link"}
            </a>
          )
        ) : (
          <p className="text-stone-200">-</p>
        ))}
      {edit && <input className="w-full form-input" {...inputOptions} />}
    </div>
  );
}
